module.exports = "// Make it safe to do console.log() always.\n(function (con) {\n  var method;\n  var dummy = function() {};\n  var methods = ('assert,count,debug,dir,dirxml,error,exception,group,' +\n     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,' + \n     'time,timeEnd,trace,warn').split(',');\n  while (method = methods.pop()) {\n    con[method] = con[method] || dummy;\n  }\n})(window.console = window.console || {});\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/source-map-loader!./vendor/scripts/console-helper.js
// module id = 670
// module chunks = 1